<template>
    <div class="position-relative">
        <hr>
        <loader-gif v-if="isRequestBilan" />
        <div class="row  mb-3">
            <div class="col-md-12">
                <h4 class="title-h4">
                    {{ i18n.t('layout.sidbar.members.bilans_list') }}
                </h4>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-12">
                <div v-if="bilansList?.length > 0" class="tab-pane fade in active show" id="bilans"
                    style="overflow-x: auto;">
                    <table v-if="bilansList?.length > 0" class="table table-striped table-bordered">
                        <thead class="thead-dark">
                            <tr>
                                <th>{{ i18n.t('tables.bilans.trainer') }}</th>
                                <th>{{ i18n.t('tables.bilans.bilan_date') }}</th>
                                <th>{{ i18n.t('tables.bilans.notes') }}</th>
                                <th>{{ i18n.t('tables.action') }}</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="bilan in bilansList" :key="`bilan-${bilan?.id}`">

                                <td>{{ bilan?.trainer?.name ?? ' - ' }}</td>
                                <td>{{ formatDate(bilan?.bilan_date) }}</td>
                                <td>{{ bilan?.notes }}</td>

                                <td>
                                    <btn-delete v-if="hasPermission('delete_member_bilan')"
                                        @delete="deleteBilanItem(bilan?.id)" />
                                    <btn-edit v-if="hasPermission('edit_member_bilan')" @edit="emiEditBilan(bilan)" />
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, toRefs, computed, PropType } from "vue";

/*plugins*/
import Swal from "sweetalert2";
import i18n from "@/i18n/index"

import { useBilan } from "@/composables/bilan/useBilan";
import { useGlobal } from "@/composables/global/useGlobal";
import { usePermission } from "@/composables/auth/usePermission";
import { useModal } from '@/composables/modal/useModal';

import { Bilan } from "@/interfaces/bilan";
import { Income } from "@/interfaces/income";

import { bilans } from "@/shared/state";

export default defineComponent({
    components: {},
    name: "list-bilans",
    emits: ['saved', 'editBilan'],
    props: {
        // bilans: {
        //     type: Array as PropType<Bilan[]>,
        //     default: null,
        // },
        income: {
            type: Object as PropType<Income | null>,
            default: null,
        }
    },

    setup(props, { emit }) {
        const { income } = toRefs(props);
        const { hasPermission } = usePermission();
        const { formatDate } = useGlobal();
        const {
            deleteBilan,
            isRequestBilan
        } = useBilan();

        const bilansList = computed(() => bilans?.data ?? []);
        const deleteBilanItem = (id: number) => {
            Swal.fire({
                title: i18n.t("message.confirmation.delete.title"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: i18n.t("button.delete"),
                cancelButtonText: i18n.t("button.cancel"),
            }).then(async (result) => {
                if (result.isConfirmed) {
                    deleteBilan(id);

                    emit('saved');
                }
            });
        };

        /**
          * Pour bilan
          */
        // const { openModal } = useModal();
        // const selectedIncome = ref({})
        // const addBilanItem = ref(null);
        // const memberUUID = ref(null);
        const emiEditBilan = (bilan: any) => {

            emit('editBilan', bilan)
        };


        return {
            emiEditBilan,
            isRequestBilan,
            hasPermission,
            deleteBilanItem,
            bilansList,
            // initStateBilan,
            i18n,
            formatDate
        };
    }
});
</script>